<template>
	<div class="ccris-derivatives">
		<b-card no-body>
			<b-card-header class="py-2 px-3">
				<h4 class="mb-0">CCRIS Derivatives</h4>
			</b-card-header>
			<b-table-simple responsive>
				<b-thead>
					<b-tr>
						<b-th>Facilities</b-th>
						<b-th class="text-right">Secured</b-th>
						<b-th class="text-right">Unsecured</b-th>
						<!-- <b-th class="text-white" v-for="person in tableData" :key="person.name" :scope="'col'">{{ person.name }}</b-th> -->
					</b-tr>
				</b-thead>
				<b-tbody v-if="!_gHlp.isEmpty(tableData)">
					<b-tr>
						<b-th scope="row"># of facilities</b-th>
						<b-td class="text-right">{{ tableData.ccris_drv_fac_sec_total || '0' | fixNumberFormat }}</b-td>
						<b-td class="text-right">{{ tableData.ccris_drv_fac_unsec_total || '0' | fixNumberFormat }}</b-td>
					</b-tr>
					<b-tr>
						<b-th scope="row">Outstanding (RM)</b-th>
						<b-td class="text-right">{{ tableData.ccris_drv_fac_sec_out_balance | moneyFormatter }}</b-td>
						<b-td class="text-right">{{ tableData.ccris_drv_fac_unsec_out_balance | moneyFormatter }}</b-td>
					</b-tr>
					<b-tr>
						<b-th scope="row">Outstanding (%)</b-th>
						<b-td class="text-right">{{ tableData.ccris_drv_fac_sec_out_limit }}</b-td>
						<b-td class="text-right">{{ tableData.ccris_drv_fac_unsec_out_limit }}</b-td>
					</b-tr>
				</b-tbody>
			</b-table-simple>
		</b-card>
	</div>
</template>
<script>
import { Card, Button } from 'element-ui'

export default {
	name: 'ccris-derivatives',
	props: ['ccris-derivatives'],
	components: {
		[Card.name]: Card,
		[Button.name]: Button,
	},
	data() {
		return {
			tableData: {}
		}
	},
	watch: {
		ccrisDerivatives: {
			handler(newVal) {
				this.tableData = newVal
			}
		},
	},
}
</script>